// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_PickupNotificationCreateResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/entregas/pickup_notifications
 *
 * Confirms creation of a pickup-notification record. Returns the new
 * notification's auto-increment ID for idempotency checking on the client.
 *
 * `portal_notification_id` and `warning` are populated only when
 * `channel === 'portal'` — every other channel is a logged assertion
 * ("staff say they told the customer"), not a system-verified delivery, so
 * neither field applies. `warning` mirrors Clientes_EnviarNotificacaoResponse:
 * null on a clean send, `no_devices` or `no_portal_account` otherwise — the
 * three staff-facing outcomes from plano-gatilhos-notificacao.md §2.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_PickupNotificationCreateResponseDados {
notification_id: number
portal_notification_id?: string
warning?: string
}

export type Orders_PickupNotificationCreateResponse = ApiResponse<Orders_PickupNotificationCreateResponseDados>;

registerResponseContract('Orders_PickupNotificationCreateResponse', {
  notification_id:        { type: 'number',  required: true },
  portal_notification_id: { type: 'string',  required: false },
  warning:                { type: 'string',  required: false },
})
